import { AddonFeatureManager } from 'core';
import { RtbCampaignSetupFlowPageModel, CreateRtbCampaignSetupFlowPageModel, EditRtbCampaignSetupFlowPageModel, CopyRtbCampaignSetupFlowPageModel, SplitRtbCampaignSetupFlowPageModel, SummaryRtbCampaignFlowPageModel } from './RtbCampaignSetupFlow/RtbCampaignSetupFlowPageModel';
import { SelectOptions } from 'components/commonType';
import { Order } from 'core/order/Order';
import { L1Object, L1ObjectChannel } from 'core/l1Object/L1Object';

export interface RtbCampaignsModel {
  readonly order: Order;
  readonly addonFeatureManager: AddonFeatureManager;
  readonly channel: L1ObjectChannel;
  getCampaignCreateModel (localeMeta): RtbCampaignSetupFlowPageModel;
  getCampaignEditModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel;
  getCampaignCopyModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel;
  getCampaignSplitModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel;
  getCampaignSummaryModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel;
  setOrder (order: Order): void;
}

export type RtbCampaignsProps = {
  readonly model: RtbCampaignsModel;
};

export class DefaultRtbCampaignsModel implements RtbCampaignsModel {

  addonFeatureManager: AddonFeatureManager;
  advertisers?: Array<SelectOptions>;
  campaignCreateModel?: RtbCampaignSetupFlowPageModel;
  campaignEditModel?: EditRtbCampaignSetupFlowPageModel;
  campaignCopyModel?: CopyRtbCampaignSetupFlowPageModel;
  campaignSplitModel?: SplitRtbCampaignSetupFlowPageModel;
  campaignSummaryModel?: SummaryRtbCampaignFlowPageModel;

  order: Order;
  channel: L1ObjectChannel;

  constructor (order: Order, addonFeatureManager: AddonFeatureManager, private l1Object: L1Object) {
    this.order = order;
    this.channel = l1Object.channel;
    this.addonFeatureManager = addonFeatureManager;
  }

  setOrder (order: Order) {
    this.order = order;
    this.campaignCreateModel && this.campaignCreateModel.setOrder(order);
    this.campaignEditModel && this.campaignEditModel.setOrder(order);
    this.campaignCopyModel && this.campaignCopyModel.setOrder(order);
    this.campaignSummaryModel && this.campaignSummaryModel.setOrder(order);
  }

  getCampaignCreateModel (localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignCreateModel) {
      return this.campaignCreateModel;
    }

    this.campaignCreateModel = new CreateRtbCampaignSetupFlowPageModel(
      this.order,
      this.addonFeatureManager,
      this.l1Object,
      localeMeta
    );
    return this.campaignCreateModel;
  }

  getCampaignEditModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignEditModel && this.campaignEditModel.campaignId === campaignId) {
      return this.campaignEditModel;
    }
    this.campaignEditModel = new EditRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      this.l1Object,
      localeMeta
    );
    return this.campaignEditModel;
  }

  getCampaignCopyModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignCopyModel && this.campaignCopyModel.campaignId === campaignId) {
      return this.campaignCopyModel;
    }

    this.campaignCopyModel = new CopyRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      this.l1Object,
      localeMeta
    );
    return this.campaignCopyModel;
  }

  getCampaignSplitModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignSplitModel && this.campaignSplitModel.campaignId === campaignId) {
      return this.campaignSplitModel;
    }

    this.campaignSplitModel = new SplitRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      this.l1Object,
      localeMeta
    );
    return this.campaignSplitModel;
  }

  getCampaignSummaryModel (campaignId: number, localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignSummaryModel && this.campaignSummaryModel.campaignId === campaignId) {
      return this.campaignSummaryModel;
    }

    this.campaignSummaryModel = new SummaryRtbCampaignFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      this.l1Object,
      localeMeta
    );
    return this.campaignSummaryModel;
  }
}
